






















// can you limit memory + cpu is just "yes"
// just your program and base os static binary
import { Component, Prop, Vue } from 'vue-property-decorator';
import Game from '../components/Game.vue';

@Component({
    components: {
        Game,
    },
})
export default class ContainerBasics extends Vue {
}
